import React from 'react';
import { Box, Container, Typography, Grid, Paper, Avatar } from '@mui/material';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const About = () => {
  const { t } = useTranslation();
  
  const skills = [
    // Programming Languages
    'Java',
    'PHP',
    'Python',
    
    // Frameworks & Libraries
    'Spring Framework',
    'React.js',
    'Next.js',
    
    // Architecture & Protocols
    'Microservices',
    'GRPC',
    'RESTful APIs',
    'Design Patterns',
    'System Design',
    
    // Databases & Search
    'RDMS',
    'NoSQL DB',
    'Elasticsearch',
    
    // Message Queues
    'Apache Kafka',
    
    // DevOps & Infrastructure
    'Docker',
    'Kubernetes',
    'Jenkins',
    'Nginx',
    'Maven'
  ];

  return (
    <Box
      id="about"
      sx={{
        py: 12,
        background: 'linear-gradient(180deg, #0a192f 0%, #020c1b 100%)',
      }}
    >
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Typography variant="h2" color="primary" sx={{ mb: 6 }}>
            {t('about.title')}
          </Typography>
        </motion.div>

        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={4}>
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  mb: { xs: 4, md: 0 }
                }}
              >
                <Avatar
                  src="/profile.jpg"
                  alt="Melihşah Akın"
                  sx={{
                    width: 250,
                    height: 250,
                    border: '4px solid',
                    borderColor: 'primary.main',
                    boxShadow: '0 0 20px rgba(144, 202, 249, 0.2)',
                  }}
                />
              </Box>
            </motion.div>
          </Grid>

          <Grid item xs={12} md={8}>
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
                {t('about.description1')}
              </Typography>
              <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
                {t('about.description2')}
              </Typography>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              <Typography variant="h6" color="primary" sx={{ mb: 3 }}>
                {t('about.skillsTitle')}
              </Typography>
              <Grid container spacing={2}>
                {skills.map((skill) => (
                  <Grid item xs={6} sm={4} md={3} key={skill}>
                    <Paper
                      elevation={0}
                      sx={{
                        height: '100%',
                        minHeight: '60px',
                        p: 2,
                        textAlign: 'center',
                        background: 'rgba(144, 202, 249, 0.08)',
                        borderRadius: 2,
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        '&:hover': {
                          background: 'rgba(144, 202, 249, 0.15)',
                          transform: 'translateY(-2px)'
                        }
                      }}
                    >
                      <Typography 
                        variant="body2"
                        sx={{
                          wordBreak: 'break-word',
                          hyphens: 'auto'
                        }}
                      >
                        {skill}
                      </Typography>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default About;
